import React, { Component } from 'react';
import { strings } from 'APP_ROOT/localization';
import PropTypes from 'prop-types';
import DataWidgetDataBar from './DataWidgetDataBar';
import DataWidgetDataBarMarkerLabel from './DataWidgetDataBarMarkerLabel';
import imageMarkerArrupUpSmall from './images/marker-arrow-up-h19.svg';

const LIMIT_WARNING_PERCENT = 90;

export default class DataWidget extends Component {

    percentageRelativeToGrandTotalAvailable = (sizeInBytes) => {
        var percentage = 0;
        return (sizeInBytes / this.props.dataUsageGrandTotalAvailable) * 100
    }
    limitWarningPercent = () => {

        var limitWarningPercent = LIMIT_WARNING_PERCENT; // default if no top ups

        if (!this.props.topUps || this.props.topUps.length === 0) {
            return limitWarningPercent;
        }

        // if top ups, then limitWarningPercent is increased relative to adding LIMIT_WARNING_PERCENT of the remaining top up
        // (in other words, the limitWarningPercent is visually just LIMIT_WARNING_PERCENT of the remaining topup)
        var dataLimitExcludingLastTopup = this.props.planTotalSizeBytes;

        const lastTopUp = this.props.topUps[this.props.topUps.length - 1];

        this.props.topUps.forEach(topUp => {
            if (topUp.ts === lastTopUp.ts) return; // exlude lastTopUp
            dataLimitExcludingLastTopup += topUp.topup;
        });

        // then add LIMIT_WARNING_PERCENT of remaining lastTopUp bytes
        dataLimitExcludingLastTopup += lastTopUp.topup * (LIMIT_WARNING_PERCENT/100);

        // then calculate that percentage out of total available bytes
        limitWarningPercent = dataLimitExcludingLastTopup/this.props.dataUsageGrandTotalAvailable * 100;

        return limitWarningPercent;
    }
    render() {

        var limitWarningPercent = this.limitWarningPercent(); // rrw increase this proportionately to the amount of top ups
        var dataUsageGrandTotalPercent = this.percentageRelativeToGrandTotalAvailable(this.props.dataUsageGrandTotalBytes)

        var dataUsageToolTip = strings.formatString(strings.data_warning_tooltip, LIMIT_WARNING_PERCENT);
        if (this.props.topUps && this.props.topUps.length > 0) {
            dataUsageToolTip = strings.formatString(strings.data_warning_tooltip_top_ups, LIMIT_WARNING_PERCENT);
        }

        var dataUsageBarComponents = [];
        var dataUsageBarMarkerLabels = [];
        var cumulativePercentageOfDataBarComponents = 0;
        cumulativePercentageOfDataBarComponents += this.percentageRelativeToGrandTotalAvailable(this.props.planTotalSizeBytes);

        if (this.props.topUps && this.props.topUps.length > 0) {

            dataUsageBarComponents.push(
                <DataWidgetDataBar
                    type = 'plan-total'
                    percentageWidth = {cumulativePercentageOfDataBarComponents}
                    key = {0.0} // unique key for element list (required by spec)
                />
            )
    
            const lastTopUp = this.props.topUps[this.props.topUps.length - 1];

            this.props.topUps.forEach((topUp, index) => {

                if (topUp.ts === lastTopUp.ts) return; // exlude lastTopUp

                dataUsageBarMarkerLabels.push(
                    <DataWidgetDataBarMarkerLabel
                        label = {strings.data_marker_label_top_up}
                        percentageLeftOffset = {cumulativePercentageOfDataBarComponents}
                        dateString = {topUp.ts}
                        key = {index + 0.1} // unique key for element list (required by spec)
                    />
                );
    
                const topUpPercentageWidth = this.percentageRelativeToGrandTotalAvailable(topUp.topup);
                cumulativePercentageOfDataBarComponents += topUpPercentageWidth;
    
                dataUsageBarComponents.push(
                    <DataWidgetDataBar
                        type = 'top-up'
                        percentageWidth = {topUpPercentageWidth}
                        key = {index + 0.2} // unique key for element list (required by spec)
                    />
                );
            });

            // add last top up label only (last top up's bar is not visible)
            dataUsageBarMarkerLabels.push(
                <DataWidgetDataBarMarkerLabel
                    label = {strings.data_marker_label_top_up}
                    percentageLeftOffset = {cumulativePercentageOfDataBarComponents}
                    dateString = {lastTopUp.ts}
                    key = {(this.props.topUps.length - 1) + 0.1} // unique key for element list (required by spec)
                />
            )
        }

        return (
            <div className="data-widget">
                <div className="data-bar-wrapper">
                    <DataWidgetDataBar
                        type = 'usage-total'
                        percentageWidth = {dataUsageGrandTotalPercent}
                    />
                    {dataUsageBarComponents}
                    <div className="warning hover-text" style={{ 'left': limitWarningPercent + '%' }}><span>&nbsp;</span></div> {/* visible marker line which will be contained/cut-off by the data-bar-wrapper if needed (at rounded corner edge) */}
                </div>
                <div className="data-bar-marker-labels">
                    {dataUsageBarMarkerLabels}
                </div>
                <div className="warning hover-text" style={{ 'left': limitWarningPercent + '%', 'opacity': '0', 'marginLeft': '-2px' }}> {/* hover field (invisible) for marker line */}
                    <span>&nbsp;</span>
                </div>
                <span>{dataUsageToolTip}</span>
                {dataUsageGrandTotalPercent >= limitWarningPercent ?
                    <p className="red">{strings.formatString(strings.data_limit_warning_message)}</p> :
                    null
                }
            </div>
        );
    }
}

DataWidget.propTypes = {
    dataUsageGrandTotalBytes: PropTypes.number.isRequired,
    dataUsageGrandTotalAvailable: PropTypes.number.isRequired,
    planTotalSizeBytes: PropTypes.number.isRequired,
    topUps: PropTypes.arrayOf(PropTypes.object) // optional
};

/*
"subscriptions": [
    {
        "currentBillingPeriod": {
            "start": "2019-07-11 17:18:40",
            "end": "2019-07-12 17:18:40"
        },
        "planCode": "freetrial3",
        "planData": 1000000000,
        "amountInCents": 0,
        "subscriptionUuid": "47a9bb8e6f73502e32064a4ca692857e",
        "dataUsage": {
            "available": 1000000000,
            "used": 29264672
            "topups": [
                {
                    "ts": "2019-06-01 18:33:28",
                    "topup": 1000000000
                },{
                    "ts": "2019-06-20 02:02:41",
                    "topup": 1000000000
                }
            ]
        },
        //// "streamingUsedPercent": 3, DEPRECATED ////
        "state": "active",
        "planSelectionRequired": false,
        "raven": {
            "ravenUuid": "83b7402ca3515b548fff009e0ad10488"
        }
    }
]
*/
